import React from 'react';
import { CustomHeader } from 'react-calendar-timeline';

interface TimelineMonthHeaderProps {
  onMonthClick: () => void;
}

const TimelineMonthHeader: React.FC<TimelineMonthHeaderProps> = ({
  onMonthClick,
}) => {
  return (
    // @ts-ignore
    <CustomHeader unit="month">
      {(props: any) => {
        const {
          headerContext: { intervals },
          getRootProps,
          getIntervalProps,
          showPeriod,
        } = props;
        return (
          <div {...getRootProps()}>
            {intervals.map((interval: any) => {
              const intervalStyle: React.CSSProperties = {
                lineHeight: '25px',
                textAlign: 'left',
                cursor: 'pointer',
                fontFamily: '"Roboto Condensed",Helvetica,Arial,"sans-serif"',
                fontSize: '13px',
                fontWeight: 'bold',
              };
              const intervalProps: any = getIntervalProps({
                interval,
                style: intervalStyle,
              });
              return (
                <div
                  key={interval.startTime.valueOf()}
                  onClick={() => {
                    showPeriod(interval.startTime, interval.endTime);
                    if (onMonthClick) {
                      onMonthClick();
                    }
                  }}
                  {...intervalProps}
                >
                  <div className="sticky stickyCentered roboto timeline-header-interval timeline-month-interval">
                    {interval.startTime.format('MMM')}
                  </div>
                </div>
              );
            })}
          </div>
        );
      }}
    </CustomHeader>
  );
};

export default TimelineMonthHeader;
